import themeColors from "./colors";
import { getEnvValue } from "@/shared/models/environment";
import themeFonts from "./fonts";
import { BRAND_LABELS } from "@/shared/constants";

export const brandLabel = getEnvValue("BRAND_LABEL") || "carconnex";

export const themes = {
    carconnex: {
        colors: themeColors.carconnex,
        fonts: themeFonts.carconnex,
    },
    astara: {
        colors: themeColors.astara,
        fonts: themeFonts.astara,
    },
};

export const brandLabelName = BRAND_LABELS[brandLabel];

export const theme = themes[brandLabel];
